import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{ active: _vm.selected }, 'content'],on:{"click":_vm.selectBusiness}},[_c('span',[_vm._v(" "+_vm._s(_vm.business.name)+" ")]),(_vm.selected)?_c(VIcon,{attrs:{"color":"primary"}},[_vm._v(" mdi-check-circle ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }